
class SelectAccount {
  constructor(inputId, listId) {
    this.input = document.getElementById(inputId);
    this.listId = listId;
    this.optionsContainer = document.getElementById(listId);
    this.init();
  }

  init() {
    if (!this.input || !this.optionsContainer) return;

    this.input.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.toggleOptionsContainer(false);
      } else {
        this.filterOptions();
      }
    });

    document.addEventListener('click', (e) => this.handleDocumentClick(e));
  }


  showAllOptions() {
    this.toggleOptionsContainer(true);
    this.toggleAllOptions(true);
  }

  filterOptions() {
    const filter = this.input.value.toLowerCase();
    const options = this.optionsContainer.querySelectorAll('.option');

    this.toggleOptionsContainer(true);

    options.forEach(option => {
      const optionText = option.textContent.toLowerCase();
      const isVisible = optionText.includes(filter);
      this.toggleOption(option, isVisible);
    });

    if (filter === '') {
      this.toggleOptionsContainer(false);
    }
  }

  toggleOptionsContainer(show) {
    if (show) {
      this.optionsContainer.classList.add('block');
      this.optionsContainer.classList.remove('hidden');
    } else {
      this.optionsContainer.classList.add('hidden');
      this.optionsContainer.classList.remove('block');
      this.input.blur();
    }
  }

  toggleAllOptions(show) {
    const options = this.optionsContainer.querySelectorAll('.option');
    options.forEach(option => this.toggleOption(option, show));
  }

  toggleOption(option, show) {
    if (show) {
      option.classList.add('block');
      option.classList.remove('hidden');
    } else {
      option.classList.add('hidden');
      option.classList.remove('block');
    }
  }

  handleDocumentClick(event) {
    const isClickOnInput = event.target === this.input;
    const isClickOnOptions = this.optionsContainer.contains(event.target);
    const isOptionsVisible = this.optionsContainer.classList.contains('block');

    if (!isClickOnInput && !isClickOnOptions) {
      this.toggleOptionsContainer(false);
      return;
    }
    if (event.target.classList.contains('option')) {
      this.input.value = event.target.textContent;
      this.toggleOptionsContainer(false);
      return;
    }

    if (isClickOnInput) {
      if (isOptionsVisible) {
        this.toggleOptionsContainer(false);
      } else {
        this.showAllOptions();
      }
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  const selectConfigs = [
    { inputId: 'club_search_input', listId: 'club_list' },
    { inputId: 'store_search_input', listId: 'store_list' },
    { inputId: 'gender_search_input', listId: 'gender_list' }
  ];

  selectConfigs.forEach(config => {
    new SelectAccount(config.inputId, config.listId);
  });
});